import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import BB from '../images/BB.png';
// import BBimage from '../images/BBimage.png';
import IconwithText from '../images/iconwithtext.png';


const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    // Clear session storage
    sessionStorage.clear();
    localStorage.clear();
    // Redirect to login page
    window.location.href = '/consumer';
  };
         
  const handleHomeClick = () => {
    window.location.href = '/consumer/projectDetails';
  };

  // Handle clicks outside the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    // Add event listener when menu is open
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Clean up event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div className='border-b-2 border-gray-200'>
      {/* Header with BB logo and hamburger menu */}
      <div className="px-2 bg-white shadow-sm py-3 flex justify-between items-center sticky top-0 z-30">
        <div onClick={() => window.location.href = '/consumer/projectDetails'}
         className="h-10">
          <img src={IconwithText} alt="Brickbucket Logo" className="h-full object-contain" />
        </div>
        <div className="relative" ref={menuRef}>
          <button 
            className="p-2 text-gray-700 hover:bg-gray-100 rounded-md"
            onClick={toggleMenu}
          >
            <svg className="w-6 h-6" fill="none" stroke="#D64541" viewBox="0 0 24 24">
  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
</svg>

          </button>
          
          {menuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-40 border border-gray-200">
              {/* <button 
                onClick={handleHomeClick}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Home
              </button> */}
               <button 
                 onClick={() => navigate('/consumer/ProfileAccount')} 
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Profile
              </button>
              <button 
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
